import { render, staticRenderFns } from "./AnalyzeAskOpinion.vue?vue&type=template&id=15034086&scoped=true&"
import script from "./AnalyzeAskOpinion.vue?vue&type=script&lang=ts&"
export * from "./AnalyzeAskOpinion.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyzeAskOpinion.vue?vue&type=style&index=0&id=15034086&prod&lang=scss&scoped=true&"
import style1 from "./AnalyzeAskOpinion.vue?vue&type=style&index=1&id=15034086&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15034086",
  null
  
)

export default component.exports